import Vue from 'vue'

var initial_data = {
    query: '',
    admin: false,
    user: {
        vm: null,
        type: null,
        profile: null,
    },
};

var shared = new Vue({
    data() {
        return initial_data;
    },
    methods: {
        sync(vm, key, opts) {
            Vue.set(vm, key, this[key]);
            var unwatch_this = this.$watch(key, (val) => {
                Vue.set(vm, key, val);
            });
            var unwatch_vm = vm.$watch(key, (val) => {
                this[key] = val;
            }, opts);
            return function() {
                unwatch_this();
                unwatch_vm();
            };
        },
    },
});

export default shared



// WEBPACK FOOTER //
// ./src/shared/index.js